import PropTypes from 'prop-types'

import dateShape from './dateShape'
import placeShape from './placeShape'
import recordTypeShape from './recordTypeShape'

export default PropTypes.shape({
  fromDate: dateShape,
  place: placeShape,
  placeOrig: PropTypes.string,
  recordType: recordTypeShape,
  recordTypeOrig: PropTypes.string,
  source: PropTypes.string,
  toDate: dateShape,
})
